import { render } from "./RecipeEditToolbar.vue?vue&type=template&id=0470fa00&scoped=true"
import script from "./RecipeEditToolbar.vue?vue&type=script&lang=js"
export * from "./RecipeEditToolbar.vue?vue&type=script&lang=js"

import "./RecipeEditToolbar.vue?vue&type=style&index=0&id=0470fa00&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0470fa00"]])

export default __exports__